//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import * as teamManagementApi from '@apis/team-management/teamManagementApi';

import {
  GetNgApiAdapterType,
  createNgApiAdapterService,
} from 'app/angular-apis/createNgApiAdapter';

// Adapting the names to match the legacy service interface here
const teamManagementApiService = createNgApiAdapterService({
  addUserAsync: teamManagementApi.addUser,
  deleteUserAsync: teamManagementApi.deleteUser,
  getAllClientsAsync: teamManagementApi.getAllClients,
  getAllUsersAsync: teamManagementApi.getAllUsers,
  getUserAsync: teamManagementApi.getUser,
  updateUserAsync: teamManagementApi.updateUser,
});
export type TeamManagementApiService = GetNgApiAdapterType<
  typeof teamManagementApiService
>;
// Backwards compatibility: Use the old service name
angular
  .module('curalate')
  .service('TeamManagementService', teamManagementApiService);
